'use client';

import { useSyncExternalStore } from 'react';

const subscribeToNothing = () => () => {};
const onClient = () => true;
const onServer = () => false;

/**
 * Whether this render may use what only the browser knows (its timezone, its
 * clock) without disagreeing with the HTML the server sent.
 *
 * False on the server and on the browser's hydrating render, which has to
 * reproduce the server's markup exactly or React discards it and renders the
 * page again from scratch. True on every render after that: React re-renders a
 * component reading this as soon as hydration is done. On a client-side
 * navigation there is no server markup to match, so it is true from the first
 * render.
 *
 * useSyncExternalStore rather than a mount effect, because React reads the
 * server snapshot while hydrating: there is no state to set, and no extra
 * render on a client-side navigation.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(subscribeToNothing, onClient, onServer);
}
